import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import AgentA from "@/pages/AgentA";
import AgentB from "@/pages/AgentB";
import LeadsPipeline from "@/pages/LeadsPipeline";
import Handoff from "@/pages/Handoff";
import DashboardLayout from "@/components/layout/DashboardLayout";
import ComingSoon, { isUnlocked, setUnlocked } from "@/pages/ComingSoon";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground font-mono text-xs">AUTHENTICATING…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function LockGate({ children }) {
  // ?preview=1 in URL grants a one-time unlock (useful for QA / testing)
  const [unlocked, setUnlockedState] = React.useState(() => {
    if (typeof window !== "undefined" && new URLSearchParams(window.location.search).get("preview") === "1") {
      setUnlocked();
      return true;
    }
    return isUnlocked();
  });
  if (!unlocked) return <ComingSoon onUnlock={() => setUnlockedState(true)} />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#0A0A0A", border: "1px solid #1A1A1A", color: "#F5F5F5" } }} />
          <LockGate>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/handoff/:token" element={<Handoff />} />
              <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
                <Route path="/app" element={<Dashboard />} />
                <Route path="/app/agent-a" element={<AgentA />} />
                <Route path="/app/agent-b" element={<AgentB />} />
                <Route path="/app/leads" element={<LeadsPipeline />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </LockGate>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
